import { replaceThousand } from 'components/footer/helpers/helperChip'
import { audioType } from 'holdem/interfaces'

export default function handleRightActions(
  audio: audioType,
  ante: string,
  AAbonus: string,
  gameState: number,
  handleRaise: () => void,
  handleDeal: (ante: string, aa: string) => void,
  handleDealOut: (b: boolean) => void,
  setIsClickable: (b: boolean) => void,
  handleActive: (s: string) => void,
  playDealSFX: () => void,
  playRaiseSFX: () => void,
  playRebetSFX: () => void,
  handleClearCards: (n: number) => void,
  handleShowResult: (b: boolean) => void,
) {
  handleShowResult(false)
  setIsClickable(true)

  let anteStake = ''
  let AAbonusStake = ''
  if (+ante < 999) {
    anteStake = ante
  } else anteStake = replaceThousand(ante).toString()


  if (+AAbonus < 999) {
    AAbonusStake = AAbonus
  } else AAbonusStake = replaceThousand(AAbonus).toString()

  if (gameState === 4) {
    handleRaise()
    audio?.sound && playRaiseSFX()
  } else if (gameState === 6 || gameState === 5 || gameState === 11) {
    handleDealOut(true)
    handleClearCards(1000)
    setTimeout(() => {
      handleDeal(anteStake, AAbonus === 'AA' ? '0' : AAbonusStake)
    }, 1000)
    audio?.sound && playRebetSFX()
  } else {
    handleDeal(anteStake, AAbonus === 'AA' ? '0' : AAbonusStake)
    handleActive('ante')
    audio?.sound && playDealSFX()
  }
}
